module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"structureTitle":"Trend tool","structureSubTitle":"Select the Deck sensors to view the data trend over time."},"it":{"structureTitle":"Tool Trends","structureSubTitle":"Seleziona i sensori Deck di cui visualizzare l’andamento dei dati nel tempo."}}')
  delete Component.options._Ctor
}
